export const TABLE_STATUS_LABELS = {
  available: 'Müsait',
  occupied: 'Dolu',
  reserved: 'Rezerve',
  inactive: 'Servis Dışı',
};

export const TABLE_SERVICE_STATE_OPTIONS = [
  { value: 'active', label: 'Aktif' },
  { value: 'inactive', label: 'Servis Dışı' },
  { value: 'reserved', label: 'Rezerve' },
];

const SERVICE_STATE_ALIASES = {
  active: 'active',
  occupied: 'active',
  busy: 'active',
  full: 'active',
  dolu: 'active',
  reserved: 'reserved',
  rezerve: 'reserved',
  inactive: 'inactive',
  disabled: 'inactive',
  pasif: 'inactive',
  cleaning: 'inactive',
  clean: 'inactive',
  temizlik: 'inactive',
  temizlikte: 'inactive',
};

export const normalizeTableServiceState = (value) => {
  const normalized = typeof value === 'string' ? value.trim().toLowerCase() : '';
  return SERVICE_STATE_ALIASES[normalized] || 'active';
};

export const resolveAdminTableDisplayStatus = (table, occupiedTableIds = new Set()) => {
  const serviceState = normalizeTableServiceState(table?.serviceState ?? table?.status);
  if (serviceState !== 'active') {
    return serviceState;
  }

  if (occupiedTableIds.has(table.id)) {
    return 'occupied';
  }

  return 'available';
};
